import { useDispatch, useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import Link from '../Link/Link';
import { PackageContainer, LinkContainer, ImageContainer } from './styles';
import { useEffect, useState } from 'react';
import api from '../../api';
import { setPackageLinksData } from '../../redux/modelDataSlice';
import { recordEvent } from '../../utils/analytics/local';
import { ReactComponent as CaseOutlineIcon } from '../../images/icons/caseOutlineIcon.svg';
import { sendAdobeEvent } from '../../utils/analytics/adobe';
import { APP_NAME } from '../../utils/constants/general';

const Package = () => {
	const packageDefinition = useSelector(state => state.designDefinition.partDefinition.package);
	const defaultMappingName = useSelector(state => state.designDefinition.partDefinition.defaultMappingName);
	const wpn = useSelector(state => state.designDefinition.partDefinition.wpn);
	const packageLinksDefinition = useSelector(state => state.designDefinition.partDefinition.package.links);
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();
	const packageLinksData = useSelector(state => state.modelData.packageLinksData);

	useEffect(() => {
		const createLinksDataRequest = () => {
			const linksParameters = packageLinksDefinition.map(column => column.id);
			return {
				opn: defaultMappingName,
				parameters: linksParameters
			};
		};

		const fetchData = async () => {
			try {
				setLoading(true);

				const fetchedData = await api.gainParametersForLinks(createLinksDataRequest());

				dispatch(setPackageLinksData(fetchedData));

				setLoading(false);
			} catch (err) {
				console.error(err);
			}
		};
		fetchData();
	}, [dispatch, defaultMappingName, packageLinksDefinition]);

	const handleEventRecord = link => {
		recordEvent(link.id, JSON.stringify(defaultMappingName));
		sendAdobeEvent(
			'Drawing',
			window.location.href,
			APP_NAME + ' | ' + defaultMappingName,
			packageLinksData[packageDefinition.links[0].id],
			null,
			wpn
		);
	};

	return (
		<PackageContainer>
			{!loading && packageLinksData[packageDefinition.links[0].id] && (
				<LinkContainer key={0}>
					<Link
						href={packageLinksData[packageDefinition.links[0].id]}
						target="_blank"
						onClick={() => {
							handleEventRecord(packageDefinition.links[0]);
						}}>
						<CaseOutlineIcon alt={packageDefinition.links[0].heading} height={32} width={32} />
					</Link>
					<Link
						href={packageLinksData[packageDefinition.links[0].id]}
						target="_blank"
						onClick={() => {
							handleEventRecord(packageDefinition.links[0]);
						}}>
						<Typography variant="subtitle2" component="h6" sx={{ ml: 1.5, mb: 0.5 }}>
							{packageDefinition.links[0].heading}
						</Typography>
					</Link>
				</LinkContainer>
			)}
			<ImageContainer>
				<Typography variant="subtitle2" component="h6">
					{packageDefinition.heading}:
				</Typography>
			</ImageContainer>
			<img src={packageDefinition.imagePath} alt={packageDefinition.heading} style={{ height: '160px' }}></img>
			{!loading &&
				packageDefinition.links.slice(1).map((link, index) => {
					if (!packageLinksData[link.id]) return null;

					return (
						<LinkContainer key={index + 1}>
							<Link href={packageLinksData[link.id]} target="_blank">
								<img src={link.iconPath} alt={link.heading} style={{ height: '32px' }}></img>
							</Link>
							<Link href={packageLinksData[link.id]} target="_blank">
								<Typography variant="subtitle2" component="h6" sx={{ ml: 1.5 }}>
									{link.heading}
								</Typography>
							</Link>
						</LinkContainer>
					);
				})}
		</PackageContainer>
	);
};

export default Package;
